(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state("Home.Tools.MarketingTrackerNew.Kits",
                {
                    url: "/Kits",
                    component: "marketingTrackerKitsNew",
                    PageTitle: "Kits | Marketing Tracker",
                    requiredOnePermission: "OnboardingKit:Access|PlanningKit:Access",
                    resolve: {
                        annualPlanningAttemptYears: ["marketingKitApi", function (marketingKitApi) {
                            return marketingKitApi.getAnnualPlanningKitYears().then(function (years) {
                                return years;
                            }, function () {
                                console.log("no years");
                                return null;
                            });
                        }]
                    }
                });
    }]);

    app
        .component("marketingTrackerKitsNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Kits/kits-new-template.html",
                controller: marketingTrackerKitsNewController,
                bindings: {
                    annualPlanningAttemptYears: "<"
                }
            });

    marketingTrackerKitsNewController.$inject = ["$state", "permissionService", "marketingKitApi", "$scope", "$interval", "amplitudeService"];
    function marketingTrackerKitsNewController($state, permissionService, marketingKitApi, $scope, $interval, amplitudeService) {
        var $ctrl = this;
        $ctrl.state = $state;
        var currentYear = (new Date()).getFullYear();
        $ctrl.year = currentYear;
        $ctrl.years = [];

        $ctrl.getAnnualPlanningKitByYear = function (year) {
            return marketingKitApi.getAnnualPlanningKitByYear(year).then(function (kit) {
                $ctrl.planningKit = kit;
                return kit;
            },
                function () {
                    return null;
                });
        };

        $ctrl.getOnboardingKit = function () {
            return marketingKitApi.getOnboardingKit().then(function (kit) {
                $ctrl.onboardingKit = kit;
                return kit;
            },
                function () {
                    return null;
                });
        };

        $ctrl.updateAnnualPlanningKitShown = function (year) {

            $ctrl.getAnnualPlanningKitByYear(year).then(function (kit) {
                $ctrl.planningKit = kit;
                $state.go("Home.Tools.MarketingTrackerNew.Kits.AnnualPlanning", { "year": year });
            });
        };

        if ($ctrl.annualPlanningAttemptYears !== null && $ctrl.annualPlanningAttemptYears.length > 0) {
            var latestYear = $ctrl.annualPlanningAttemptYears[0].Year;
            var earliestYear = $ctrl.annualPlanningAttemptYears.slice(-1)[0].Year;

            if (earliestYear > currentYear) {
                for (var i = parseInt(currentYear); i <= parseInt(earliestYear) + 1; i++)
                    $ctrl.years.push(parseInt(i));
            } else {
                for (var j = parseInt(earliestYear); j <= parseInt(currentYear) + 1; j++)
                    $ctrl.years.push(parseInt(j));
            }

            $ctrl.year = latestYear;
            $ctrl.updateAnnualPlanningKitShown(latestYear);
        }

        else if ($ctrl.annualPlanningAttemptYears !== null && $ctrl.annualPlanningAttemptYears.length === 0) {
            for (var k = $ctrl.year; k <= currentYear + 1; k++)
                $ctrl.years.push(parseInt(k));

            $ctrl.updateAnnualPlanningKitShown($ctrl.year);
        }

        else {
            for (var l = $ctrl.year; l <= currentYear + 1; l++)
                $ctrl.years.push(parseInt(l));
            $state.go("Home.Tools.MarketingTrackerNew.Kits.Onboarding");
        }

        $ctrl.$onInit = function () {
            $ctrl.getOnboardingKit();
        };    
      
    }

})(window.app, window.angular); // jshint ignore:line